<template>
    <div ref="wrapperRef" class="flex">
        <Tooltip :is-disabled="props.status === 'Focused' || props.status === 'Open'" :is-teleported="true">
            <template #trigger="tooltipProps">
                <button
                    v-bind="tooltipProps"
                    class="inline-flex flex-row gap-px relative outline-hidden z-10"
                    :class="[
                        props.isClickable ? 'cursor-pointer' : 'cursor-not-allowed',
                        {
                            'wrapper-border wrapper-border-gray-700': props.status === 'Focused',
                            'wrapper-border wrapper-border-gray-700-50': props.status === 'Hovered',
                            'wrapper-border wrapper-border-gray-50': props.status === 'Default',
                            'bg-gray-50': props.status !== 'Open',
                            'rounded-l-full before:rounded-l-full':
                                props.form === 'Start-End' || props.form === 'Start-Middle',
                            'rounded-r-full before:rounded-r-full':
                                props.form === 'Start-End' || props.form === 'Middle-End',
                        },
                    ]"
                    :aria-disabled="!props.isClickable"
                    type="button"
                >
                    <slot />
                </button>
            </template>

            <template v-if="$slots['tooltip-header']" #header>
                <slot name="tooltip-header" />
            </template>

            <template #text>
                <slot name="tooltip-text" />
            </template>
        </Tooltip>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Tooltip from '../../Tooltip/Tooltip.vue';

type AllocationWrapperProps = {
    status: 'Default' | 'Hovered' | 'Focused' | 'Open';
    isClickable: boolean;
    form: 'Start-End' | 'Start-Middle' | 'Middle' | 'Middle-End';
};

const props = defineProps<AllocationWrapperProps>();

const wrapperRef = ref();
defineExpose({
    wrapperRef,
});
</script>

<style scoped>
@reference "../../../tailwind.css";

.wrapper-border::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
}

.wrapper-border-gray-700::before {
    border: 1px solid var(--color-gray-700);
}

.wrapper-border-gray-700-50::before {
    @apply border border-gray-700/50;
}

.wrapper-border-gray-50::before {
    border: 1px solid var(--color-gray-50);
}
</style>
